import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const DeployIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props} fill="none">
      <path
        d="M6.99999 14C5.95922 14.5876 5.11765 15.4726 4.58315 16.5416C4.04865 17.6106 3.84559 18.8148 3.99999 20C5.18515 20.1544 6.38942 19.9513 7.45841 19.4168C8.52741 18.8823 9.41242 18.0408 9.99999 17M3.99999 13C5.78309 13.2119 7.44304 14.0175 8.71275 15.2872C9.98246 16.557 10.7881 18.2169 11 20C11.8839 19.4904 12.6233 18.7638 13.1482 17.8889C13.6732 17.014 13.9663 16.0197 14 15C15.6791 14.4093 17.1454 13.334 18.2133 11.91C19.2813 10.486 19.9031 8.77734 20 7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4C15.2227 4.09691 13.514 4.71867 12.09 5.78665C10.666 6.85464 9.59068 8.32089 8.99999 10C7.98026 10.0337 6.98595 10.3268 6.11106 10.8518C5.23616 11.3767 4.50958 12.1161 3.99999 13ZM14 9C14 9.26522 14.1053 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9C16 8.73478 15.8946 8.48043 15.7071 8.29289C15.5196 8.10536 15.2652 8 15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1053 8.48043 14 8.73478 14 9Z"
        stroke="#5f5e70"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
